import type { LearningVideo } from './learning-video-modal.tsx';

export const customStreamTutorialVideo: LearningVideo = {
  id: 'buy-and-use-a-custom-data-stream',
  s3Key: 'service/onboarding-videos/Buy custom stream.mp4',
  title: 'Buy and use a custom data stream',
};
